// extracted by mini-css-extract-plugin
module.exports = {"loader":"page-loader_t41Y6","light":"page-loader_z4Sfy","dark":"page-loader_fXFWh","srOnly":"page-loader_10m99"};